import React, {Component} from 'react';
import axios from 'axios';
import Breadcrumb from  '../../Layout/Breadcrumb';
import { Card, CardBody } from 'reactstrap';
import { FaProductHunt } from "react-icons/fa";
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner, Tabs, Tab } from 'react-bootstrap';
import { Link } from 'react-router-dom';

class EditProductComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadPage: false,
            isLoading: false,
            name: '',
            groupProductId: "",
            packageId: "",
            listGroupProduct: [],
            listPackage: {},
            listGroupEmail: {},
            error: false,
            messageError: '',
            disabledPricing: true,
            isConfig: false,
            chossePackage: [],
            description: "",
            emailCreate: "",
            emailPayment: "",
            emailExpire: "",
            hidden: false,
            monthly: "0",
            twomonthly: "0",
            quarterly: "0",
            semi_annually: "0",
            annually: "0",
            biennially: "0",
            triennially: "0",
            one_time_pay: "0",
            qtt: "10",
            btnSubmit: false,
            errorForm: false,
            messageForm: "",
            textMothly: "0",
            textTypeProxy: {
                'vn': "HTTP Proxy Việt Nam",
                'vns': "Sock5 Proxy Việt Nam",
                'us': "Sock5 Proxy US",
                'usp': "HTTP Proxy US",
                'uk': "Proxy UK",
                'ca': "Proxy Canada",
                'si': "Sock5 Proxy Singapore",
                'sip': "HTTP Proxy Singapore",
                'jp': "Sock5 Proxy Japan",
                'jpp': "HTTP Proxy Japan",
            },
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getConfigEditProduct( this.props.productId );
    }

    getConfigEditProduct = (productId) => {
        this.setState({
            loadPage: true
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/product/getConfigEditProduct/' + productId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    // lưu vào state
                    this.setState({
                        listGroupProduct: ref.data.listGroupProduct,
                        listPackage: ref.data.listPackage,
                        listGroupEmail: ref.data.listGroupEmail,
                        name: ref.data.product.name,
                        groupProductId: ref.data.product.group_product_id,
                        packageId: ref.data.product.package_id,
                        description: ref.data.product.description,
                        emailCreate: ref.data.product.product_detail.email_order_id,
                        emailPayment: ref.data.product.product_detail.email_payment_id,
                        emailExpire: ref.data.product.product_detail.email_expire_id,
                        monthly: ref.data.product.product_pricing.monthly,
                        twomonthly: ref.data.product.product_pricing.twomonthly,
                        quarterly: ref.data.product.product_pricing.quarterly,
                        semi_annually: ref.data.product.product_pricing.semi_annually,
                        annually: ref.data.product.product_pricing.annually,
                        biennially: ref.data.product.product_pricing.biennially,
                        triennially: ref.data.product.product_pricing.triennially,
                        one_time_pay: ref.data.product.product_pricing.one_time_pay,
                        qtt: ref.data.product.stt,
                        loadPage: false
                    })

                    let packageId = ref.data.product.package_id;
                    // console.log(ref.data.listPackage, packageId)
                    Object.entries(ref.data.listPackage).forEach( (listPackage) => {
                        listPackage[1].packages.forEach( ( packageGroup ) => {
                            if ( packageGroup.id === packageId ) {
                                this.setState({
                                    isConfig: true,
                                    chossePackage: packageGroup,
                                    disabledPricing: false,
                                    loadPage: false
                                })
                            }
                        })
                    })
                }
                else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu sản phẩm thất bại',
                    isLoading: false
                })
            })

    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        // console.log(name, value)
        this.setState({
            [name]: value
        });
    }

    changePackage = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
        Object.entries(this.state.listPackage).forEach( (listPackage) => {
            listPackage[1].packages.forEach( ( packageGroup ) => {
                if ( packageGroup.id === parseInt(value) ) {
                    this.setState({
                        isConfig: true,
                        chossePackage: packageGroup,
                        disabledPricing: false
                    })
                }
            })
        })
    }
    // loadFormCreate
    loadFormCreate = () => {
        // console.log(this.state.isConfig)
        return (
            <>
                <Card>
                    <CardBody>
                        <div className="form-group row">
                            <label htmlFor="name" className="col-sm-2 col-form-label text-center">Tên sản phẩm</label>
                            <div className="col-sm-10">
                                <input type="text" name="name" className="form-control" id="name"
                                       placeholder="Tên sản phẩm" onChange={this.changeInput} value={ this.state.name }
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="groupProductId" className="col-sm-2 col-form-label text-center">Nhóm sản phẩm</label>
                            <div className="col-sm-10">
                                <select className="form-control" name="groupProductId" id="groupProductId" onChange={this.changeInput}
                                        defaultValue={ this.state.groupProductId } value={ this.state.groupProductId }
                                >
                                    <option value="" disabled>Chọn nhóm sản phẩm</option>
                                    {
                                        this.state.listGroupProduct.length ? (
                                            this.state.listGroupProduct.map( (groupProduct, indexGroup) => (
                                                <option value={groupProduct.id} key={indexGroup}>{groupProduct.name}</option>
                                            ))
                                        ) : (
                                            <></>
                                        )
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="packageId" className="col-sm-2 col-form-label text-center">Gói sản phẩm</label>
                            <div className="col-sm-10">
                                <select className="form-control" name="packageId" id="packageId" onChange={this.changePackage}
                                        defaultValue={this.state.packageId}  value={ this.state.packageId }
                                >
                                    <option value="" disabled>Chọn gói sản phẩm</option>
                                    {
                                        Object.keys(this.state.listPackage).length ? (
                                            this.listOptPackage()
                                        ) : (
                                            <></>
                                        )
                                    }
                                </select>
                            </div>
                        </div>
                        {
                            this.state.isConfig ? (
                                <>
                                    { this.loadConfigProduct() }
                                    { this.loadFormByType() }
                                </>
                            ) : (
                                <></>
                            )
                        }
                    </CardBody>
                </Card>
            </>
        )
    }

    listOptPackage = () => {
        // console.log(this.state.listPackage)
        return (
            Object.entries(this.state.listPackage).map( (listPackage, index) => (
                <optgroup label={listPackage[1].title} key={index}>
                    {
                        Object.keys(listPackage[1].packages).length ?
                            (
                                listPackage[1].packages.map( ( packageGroup, indexGroup ) => (
                                    <option value={packageGroup.id} key={indexGroup}>{ packageGroup.title }</option>
                                ))
                            ) : (
                                <></>
                            )
                    }
                </optgroup>
            ))

        )
    }

    loadConfigProduct = () => {
        // console.log(this.state.chossePackage.type)
        if ( this.state.chossePackage.type === 'VPS' || this.state.chossePackage.type === 'VPS-US'
            || this.state.chossePackage.type === 'Cloud-Server' || this.state.chossePackage.type === 'NAT-VPS'
            || this.state.chossePackage.type === 'VPS-Canada' || this.state.chossePackage.type === 'VPS-UK'
            || this.state.chossePackage.type === 'VPS-Singapore' || this.state.chossePackage.type === 'VPS-Japan'
        ) {
            return (
                <>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">CPU</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.cpu } disabled={true} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">RAM</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.ram } disabled={true} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">DISK</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.disk } disabled={true} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">IP</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.ip } disabled={true} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">Hệ điều hành</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.os } disabled={true} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">Băng thông</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.bandwidth } disabled={true} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">Sản phẩm đặc biệt</label>
                        <div className="col-sm-10">
                            {
                                this.state.chossePackage.package_detail.special ? (
                                    <div className="text-success">
                                        Có
                                    </div>
                                ) : (
                                    <>
                                        Không
                                    </>
                                )
                            }
                        </div>
                    </div>
                </>
            )
        }
        else if ( this.state.chossePackage.type === "Proxy" ) {
            return (
                <>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">Băng thông</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.bandwidth } disabled={true} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">IP</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.ip } disabled={true} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">Loại Proxy</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control"
                                   value={ this.state.textTypeProxy[this.state.chossePackage.package_detail.os] }
                                   disabled={true}
                            />
                        </div>
                    </div>
                </>
            )
        }
        else if ( this.state.chossePackage.type === 'Hosting Cpanel' ) {
            return (
                <>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">Dung lượng</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.storage } disabled={true} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">Số lượng domain</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.domain } disabled={true} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">Số lượng sub domain</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.sub_domain } disabled={true} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">Alias domain</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.alias_domain } disabled={true} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">Database</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.database } disabled={true} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">Ftp</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.ftp } disabled={true} />
                        </div>
                    </div>
                </>
            )
        }
        else if ( this.state.chossePackage.type === 'Addon-VPS' || this.state.chossePackage.type === 'Addon-Cloud-Server' ) {
            if ( this.state.chossePackage.package_detail.type_addon === 'addon_cpu' ) {
                return (
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">Addon CPU</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.cpu } disabled={true} />
                        </div>
                    </div>
                )
            }
            else if ( this.state.chossePackage.package_detail.type_addon === 'addon_ram' ) {
                return (
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">Addon RAM</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.ram } disabled={true} />
                        </div>
                    </div>
                )
            }
            else if ( this.state.chossePackage.package_detail.type_addon === 'addon_disk' ) {
                return (
                    <div className="form-group row">
                        <label className="col-sm-2 col-form-label text-center">Addon DISK</label>
                        <div className="col-sm-10">
                            <input type="text" className="form-control" value={ this.state.chossePackage.package_detail.disk } disabled={true} />
                        </div>
                    </div>
                )
            }
        }
    }

    loadFormByType = () => {
        if ( this.state.chossePackage.type === 'VPS' || this.state.chossePackage.type === 'VPS-US'
            || this.state.chossePackage.type === 'Cloud-Server' || this.state.chossePackage.type === 'Hosting Cpanel'
            || this.state.chossePackage.type === 'NAT-VPS'
            || this.state.chossePackage.type === 'VPS-Canada' || this.state.chossePackage.type === 'VPS-UK'
            || this.state.chossePackage.type === 'VPS-Singapore' || this.state.chossePackage.type === 'VPS-Japan'
        ) {
            return (
                <>
                    <div className="form-group row">
                        <label htmlFor="qtt" className="col-sm-2 col-form-label text-center">Số thứ tự</label>
                        <div className="col-sm-10">
                            <input type="text" name="qtt" className="form-control" defaultValue={ this.state.qtt }  onChange={this.changeInput} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="description" className="col-sm-2 col-form-label text-center">Mô tả</label>
                        <div className="col-sm-10">
                            <textarea name="description" id="description" className="form-control" defaultValue={ this.state.description } />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="emailCreate" className="col-sm-2 col-form-label text-center">Email tạo đơn hàng</label>
                        <div className="col-sm-10">
                            <select className="form-control" name="emailCreate" id="emailCreate" onChange={this.changeInput}
                                    defaultValue={ this.state.emailCreate } value={ this.state.emailCreate }
                            >
                                <option value="" disabled>Chọn email tạo</option>
                                { this.loadOtpEmail() }
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="emailPayment" className="col-sm-2 col-form-label text-center">Email thanh toán tạo</label>
                        <div className="col-sm-10">
                            <select className="form-control" name="emailPayment" id="emailPayment" onChange={this.changeInput}
                                    defaultValue={ this.state.emailPayment } value={ this.state.emailPayment }
                            >
                                <option value="" disabled>Chọn email thanh toán tạo</option>
                                { this.loadOtpEmail() }
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="emailExpire" className="col-sm-2 col-form-label text-center">Email thanh toán gia hạn</label>
                        <div className="col-sm-10">
                            <select className="form-control" name="emailExpire" id="emailExpire" onChange={this.changeInput}
                                    defaultValue={ this.state.emailExpire } value={ this.state.emailExpire }
                            >
                                <option value="" disabled>Chọn email thanh toán gia hạn</option>
                                { this.loadOtpEmail() }
                            </select>
                        </div>
                    </div>
                    {/*<div className="form-group row">*/}
                    {/*    <label htmlFor="hidden" className="col-sm-2 col-form-label text-center">Ẩn sản phẩm</label>*/}
                    {/*    <div className="col-sm-10">*/}
                    {/*        <input type="checkbox" name="hidden" className="form-controll" defaultValue={ this.state.hidden } onChange={this.changeInput}  />*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </>
            )
        }
        else if ( this.state.chossePackage.type === 'Proxy' ) {
            return (
                <>
                    <div className="form-group row">
                        <label htmlFor="description" className="col-sm-2 col-form-label text-center">Mô tả loại Proxy</label>
                        <div className="col-sm-10">
                            <input type="text" name="description" id="description" className="form-control" defaultValue={ this.state.chossePackage.description } disabled={true} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="qtt" className="col-sm-2 col-form-label text-center">Số thứ tự</label>
                        <div className="col-sm-10">
                            <input type="text" name="qtt" className="form-control" defaultValue={ this.state.qtt } onChange={this.changeInput}  />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="emailCreate" className="col-sm-2 col-form-label text-center">Email tạo đơn hàng</label>
                        <div className="col-sm-10">
                            <select className="form-control" name="emailCreate" id="emailCreate" onChange={this.changeInput}
                                    defaultValue={ this.state.emailCreate } value={ this.state.emailCreate }
                            >
                                <option value="" disabled>Chọn email tạo</option>
                                { this.loadOtpEmail() }
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="emailPayment" className="col-sm-2 col-form-label text-center">Email thanh toán tạo</label>
                        <div className="col-sm-10">
                            <select className="form-control" name="emailPayment" id="emailPayment" onChange={this.changeInput}
                                    defaultValue={ this.state.emailPayment } value={ this.state.emailPayment }
                            >
                                <option value="" disabled>Chọn email thanh toán tạo</option>
                                { this.loadOtpEmail() }
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="emailExpire" className="col-sm-2 col-form-label text-center">Email thanh toán gia hạn</label>
                        <div className="col-sm-10">
                            <select className="form-control" name="emailExpire" id="emailExpire" onChange={this.changeInput}
                                    defaultValue={ this.state.emailExpire } value={ this.state.emailExpire }
                            >
                                <option value="" disabled>Chọn email thanh toán gia hạn</option>
                                { this.loadOtpEmail() }
                            </select>
                        </div>
                    </div>
                </>
            )
        }
        else if ( this.state.chossePackage.type === 'Addon-VPS' || this.state.chossePackage.type === 'Addon-Cloud-Server' ) {
            return (
                <>
                    <div className="form-group row">
                        <label htmlFor="qtt" className="col-sm-2 col-form-label text-center">Số thứ tự</label>
                        <div className="col-sm-10">
                            <input type="text" name="qtt" className="form-control" defaultValue={ this.state.qtt } onChange={this.changeInput}  />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="description" className="col-sm-2 col-form-label text-center">Mô tả</label>
                        <div className="col-sm-10">
                            <textarea name="description" id="description" className="form-control" defaultValue={ this.state.description } />
                        </div>
                    </div>
                </>
            )
        }
    }

    loadOtpEmail = () => {
        return (
            this.state.listGroupEmail.length ? (
                this.state.listGroupEmail.map( (emailGroup, indexGroup) => (
                    <optgroup label={emailGroup.title} key={indexGroup}>
                        {
                            emailGroup.emails.length ? (
                                emailGroup.emails.map( (email, indexEmail) => (
                                    <option value={email.id} key={indexEmail}>{email.title}</option>
                                ))
                            ) : (
                                <></>
                            )
                        }
                    </optgroup>
                ))
            ) : (
                <></>
            )
        )
    }
    // ./loadFormCreate
    // listFormPricing
    listFormPricing = () => {
        if ( this.state.isConfig ) {
            return (
                <>
                    <Card>
                        <CardBody>
                            { this.loadConfigPricing() }
                            { this.loadFormPricing() }
                        </CardBody>
                    </Card>
                </>
            );
        }
    }

    loadConfigPricing = () => {
        return (
            <div className="product-info rounded">
                <p className="product-title">
                    { this.state.chossePackage.title }
                </p>
                <p className="config-product">
                    Loại thanh toán: { this.state.chossePackage.package_pricing.type === 'one_time' ? 'Một lần' : 'Định kỳ' } <br/>
                    Chi phí gốc mua từ Cloudzone: <br/>
                    {
                        this.state.chossePackage.package_pricing.type === 'one_time' ? (
                            <div className="pl-2 mt-1">
                                Một lần: { this.addCommas( this.state.chossePackage.package_pricing.one_time_pay ) } VNĐ <br/>
                            </div>
                        ) : (
                            <div className="pl-2 mt-1">
                                { this.loadCost() }
                            </div>
                        )
                    }
                </p>
            </div>
        )
    }

    loadCost = () => {
        return (
            <>
                {
                    this.state.chossePackage.package_pricing.monthly ? (
                        <>
                            1 tháng: { this.addCommas( this.state.chossePackage.package_pricing.monthly ) } VNĐ <br/>
                        </>
                    ) : (
                        <></>
                    )
                }
                {
                    this.state.chossePackage.package_pricing.twomonthly ? (
                        <>
                            2 tháng: { this.addCommas( this.state.chossePackage.package_pricing.twomonthly ) } VNĐ <br/>
                        </>
                    ) : (
                        <></>
                    )
                }
                {
                    this.state.chossePackage.package_pricing.quarterly ? (
                        <>
                            3 tháng: { this.addCommas( this.state.chossePackage.package_pricing.quarterly ) } VNĐ <br/>
                        </>
                    ) : (
                        <></>
                    )
                }
                {
                    this.state.chossePackage.package_pricing.semi_annually ? (
                        <>
                            6 tháng: { this.addCommas( this.state.chossePackage.package_pricing.semi_annually ) } VNĐ <br/>
                        </>
                    ) : (
                        <></>
                    )
                }
                {
                    this.state.chossePackage.package_pricing.annually ? (
                        <>
                            1 Năm: { this.addCommas( this.state.chossePackage.package_pricing.annually ) } VNĐ <br/>
                        </>
                    ) : (
                        <></>
                    )
                }
                {
                    this.state.chossePackage.package_pricing.biennially ? (
                        <>
                            2 Năm: { this.addCommas( this.state.chossePackage.package_pricing.biennially ) } VNĐ <br/>
                        </>
                    ) : (
                        <></>
                    )
                }
                {
                    this.state.chossePackage.package_pricing.triennially ? (
                        <>
                            3 Năm: { this.addCommas( this.state.chossePackage.package_pricing.triennially ) } VNĐ <br/>
                        </>
                    ) : (
                        <></>
                    )
                }
            </>
        );
    }

    loadFormPricing = () => {
        return (
            <>
                {
                    this.state.chossePackage.package_pricing.type === 'one_time' ? (
                        <>
                            {
                                this.state.chossePackage.package_pricing.one_time_pay ? (
                                    <div className="form-group row">
                                        <label htmlFor="one_time_pay" className="col-sm-2 col-form-label text-center">Một Lần</label>
                                        <div className="col-sm-10">
                                            <input type="number" name="one_time_pay" className="form-control" id="one_time_pay"
                                                   onChange={this.changeInput} defaultValue={ this.state.one_time_pay } value={ this.state.textMothly }
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )
                            }
                        </>
                    ) : (
                        <>
                            {
                                this.state.chossePackage.package_pricing.monthly ? (
                                    <div className="form-group row">
                                        <label htmlFor="monthly" className="col-sm-2 col-form-label text-center">1 tháng</label>
                                        <div className="col-sm-10">
                                            <input type="number" name="monthly" className="form-control" id="monthly"
                                                   onChange={this.changeInput} defaultValue={ this.state.monthly }
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.state.chossePackage.package_pricing.twomonthly ? (
                                    <div className="form-group row">
                                        <label htmlFor="twomonthly" className="col-sm-2 col-form-label text-center">2 tháng</label>
                                        <div className="col-sm-10">
                                            <input type="number" name="twomonthly" className="form-control" id="twomonthly"
                                                   onChange={this.changeInput} defaultValue={ this.state.twomonthly }
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.state.chossePackage.package_pricing.quarterly ? (
                                    <div className="form-group row">
                                        <label htmlFor="quarterly" className="col-sm-2 col-form-label text-center">3 tháng</label>
                                        <div className="col-sm-10">
                                            <input type="number" name="quarterly" className="form-control" id="quarterly"
                                                   onChange={this.changeInput} defaultValue={ this.state.quarterly }
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.state.chossePackage.package_pricing.semi_annually ? (
                                    <div className="form-group row">
                                        <label htmlFor="semi_annually" className="col-sm-2 col-form-label text-center">6 tháng</label>
                                        <div className="col-sm-10">
                                            <input type="number" name="semi_annually" className="form-control" id="semi_annually"
                                                   onChange={this.changeInput} defaultValue={ this.state.semi_annually }
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.state.chossePackage.package_pricing.annually ? (
                                    <div className="form-group row">
                                        <label htmlFor="annually" className="col-sm-2 col-form-label text-center">1 Năm</label>
                                        <div className="col-sm-10">
                                            <input type="number" name="annually" className="form-control" id="annually"
                                                   onChange={this.changeInput} defaultValue={ this.state.annually }
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.state.chossePackage.package_pricing.biennially ? (
                                    <div className="form-group row">
                                        <label htmlFor="biennially" className="col-sm-2 col-form-label text-center">2 Năm</label>
                                        <div className="col-sm-10">
                                            <input type="number" name="biennially" className="form-control" id="biennially"
                                                   onChange={this.changeInput} defaultValue={ this.state.biennially }
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.state.chossePackage.package_pricing.triennially ? (
                                    <div className="form-group row">
                                        <label htmlFor="triennially" className="col-sm-2 col-form-label text-center">3 Năm</label>
                                        <div className="col-sm-10">
                                            <input type="number" name="triennially" className="form-control" id="triennially"
                                                   onChange={this.changeInput} defaultValue={ this.state.triennially }
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )
                            }
                        </>
                    )
                }
            </>
        );
    }

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }
    // ./listFormPricing
    //submit
    submit = () => {
        // console.log(this.state.qtt)
        this.setState({
            btnSubmit: true,
        })
        if ( this.validate() ) {
            this.setState({
                loadPage: true
            })
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let form = {
                productId: this.props.productId,
                name: this.state.name,
                groupProductId: this.state.groupProductId,
                packageId: this.state.packageId,
                stt: this.state.qtt,
                description: this.state.description,
                emailCreate: this.state.emailCreate,
                emailPayment: this.state.emailPayment,
                emailExpire: this.state.emailExpire,
                hidden: this.state.hidden,
                monthly: this.state.monthly,
                twomonthly: this.state.twomonthly,
                quarterly: this.state.quarterly,
                semi_annually: this.state.semi_annually,
                annually: this.state.annually,
                biennially: this.state.biennially,
                triennially: this.state.triennially,
                one_time_pay: this.state.one_time_pay,
            };

            axios.put( process.env.REACT_APP_API_URL + '/api/admin/product/editProduct', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    this.setState({
                        loadPage: false,
                        btnSubmit: false
                    });
                    if ( ref.data.error === 0 ) {
                        this.redirect();
                    } else {
                        if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                            this.props.logOut();
                        } else {
                            this.setState({
                                errorForm: true,
                                messageForm: ref.data.message,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        errorForm: true,
                        messageForm: 'Chỉnh sửa sản phẩm thất bại',
                        loadPage: false,
                        name: '',
                        btnSubmit: false
                    })
                })
        }
    }

    validate = () => {
        if ( this.state.name.length < 4 || this.state.name.length > 200 ) {
            this.setState({
                errorForm: true,
                messageForm: "Số ký tự của Tên sản phẩm không được nhỏ hơn 4 ký tự hoặc lớn hơn 200 ký tự"
            })
            return false;
        }
        else if ( this.state.groupProductId === "" ) {
            this.setState({
                errorForm: true,
                messageForm: "Nhóm sản phẩm không được để trống"
            })
            return false;
        }
        else if ( this.state.packageId === "" ) {
            this.setState({
                errorForm: true,
                messageForm: "Gói sản phẩm không được để trống"
            })
            return false;
        }
        if ( this.state.chossePackage.type === 'Addon-VPS' || this.state.chossePackage.type === 'Addon-Cloud-Server' ) {
            if ( this.state.emailCreate === "" ) {
                this.setState({
                    errorForm: true,
                    messageForm: "Email tạo đơn hàng không được để trống"
                })
                return false;
            }
            else if ( this.state.emailPayment === "" ) {
                this.setState({
                    errorForm: true,
                    messageForm: "Email thanh toán không được để trống"
                })
                return false;
            }
            else if ( this.state.emailExpire === "" ) {
                this.setState({
                    errorForm: true,
                    messageForm: "Email gia hạn không được để trống"
                })
                return false;
            }
        }
        return true;
    }

    redirect = () => {
        this.props.notification({
            isNotification: true,
            textNotification: 'Chỉnh sửa sản phẩm thành công'
        });
        this.props.shouldRedirect();
    }
    // ./submit
    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Chỉnh sửa sản phẩm"} page={"Sản phẩm"} icon={<FaProductHunt className="breadcrumb-icon"/>}/>
                            {
                                this.state.error ? (
                                    <Alert color="danger">
                                        <div className='text-center'>
                                            { this.state.messageError }
                                        </div>
                                    </Alert>
                                ) : (
                                    <>
                                        {
                                            this.state.errorForm ? (
                                                <Alert color="danger">
                                                    { this.state.messageForm }
                                                </Alert>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        <Tabs defaultActiveKey="config" id="uncontrolled-tab-example" className="mb-3 tab-menu">
                                            <Tab eventKey="config" title="Thiết lập">
                                                { this.loadFormCreate() }
                                            </Tab>
                                            <Tab eventKey="pricing" title="Chi phí" className="mb-3 tab-menu" disabled={ this.state.disabledPricing }>
                                                { this.listFormPricing() }
                                            </Tab>
                                        </Tabs>
                                        <div className="form-footer text-center pt-3">
                                            <Link className="btn btn-default mr-2" to="/admin/san-pham">Trở lại</Link>
                                            <button className="btn btn-primary mr-2" onClick={ () => this.submit() } disabled={ this.state.btnSubmit }>Chỉnh sửa</button>
                                        </div>
                                    </>
                                )
                            }
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminEditProduct' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EditProductComponent);